export default {
  selectedSection: {
    isFetching: true
  }
};
